<template>
  <div>
    <div>
      <input
        v-model="searchQuery"
        v-sanitize
        class="search-table"
        type="search"
        :placeholder="$t('jurisdictions.search')"
      >
    </div>
    <b-overlay
      :show="loadingJurisdictionsList"
      :variant="'white'"
      :opacity="0.6"
      rounded="sm"
    >
      <div class="above-jurisdictionsList">
        <div />
        <Pagination
          v-if="jurisdictionsCount > $config.itemsPerPage.jurisdictions && jurisdictionsList && jurisdictionsCount > 0"
          :current-page="currentPage"
          :nb-pages="Math.ceil(jurisdictionsCount / $config.itemsPerPage.jurisdictions)"
          class="jurisdictionsList-pagination"
          @change-page="$event => currentPage = $event"
          v-on="$listeners"
        />
        <div />
      </div>
      <table class="table table-bordered table-hover align-middle mt-2">
        <thead
          v-if="jurisdictionsList && jurisdictionsList.length"
          class="table-dark"
        >
          <tr>
            <th scope="col">
              {{ $t('words.name') }}
            </th>
            <th scope="col">
              {{ capitalizeFirstLetter($t('jurisdictions.form.identificationCode')) }}
            </th>
            <th
              scope="col"
              style="text-align: center;"
            >
              {{ capitalizeFirstLetter($tc('words.municipality', 2)) }}
            </th>
            <th
              scope="col"
              style="text-align: center;"
            >
              {{ $t('buttons.delete') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="jurisdiction of jurisdictionsList"
            :key="`jurisdiction-row-${jurisdiction.id}`"
            @click="$router.push({
              name: 'JurisdictionDetail',
              params: {
                id: jurisdiction.id,
              }
            })"
          >
            <td>
              {{ jurisdiction.display_name }}
            </td>
            <td>
              {{ jurisdiction.codename }}
            </td>
            <td style="text-align: center;">
              {{ jurisdiction.municipalities.length }}
            </td>
            <td style="text-align: center;">
              <img
                class="delete-icon"
                src="@/assets/icons/trash_delete.svg"
                alt="Icon trash delete"
                @click.stop="deleteJurisdiction(jurisdiction)"
              >
            </td>
          </tr>
        </tbody>
      </table>
      <Pagination
        v-if="jurisdictionsCount > $config.itemsPerPage.jurisdictions && jurisdictionsList && jurisdictionsCount > 0"
        :current-page="currentPage"
        :nb-pages="Math.ceil(jurisdictionsCount / $config.itemsPerPage.jurisdictions)"
        class="jurisdictionsList-pagination"
        @change-page="$event => currentPage = $event"
        v-on="$listeners"
      />
    </b-overlay>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';
import { ErrorService } from '@/services/error-service.js';

import Pagination from '@/components/Elements/Pagination.vue';

export default {
  name: 'JurisdictionsTable',

  components: {
    Pagination
  },

  data() {
    return {
      loadingJurisdictionsList: false,
      searchQuery: null,
      currentPage: 1,
      jurisdictionToDelete: null
    };
  },

  computed: {
    ...mapState('jurisdiction', [
      'jurisdictionsCount',
      'jurisdictionsList',
      'isJurisdictionsListSearched',
      'searchJurisdictionsFilter',
      'jurisdictionsListCurrentPage'
    ]),
  },

  watch: {
    searchQuery: _.debounce(async function(newValue) {
      this.loadingJurisdictionsList = true;
      try {
        const searched = await this.SEARCH_JURISDICTIONS_LIST({
          text: newValue,
        });
        if (searched) {
          this.loadingJurisdictionsList = false;
        }
      } catch (err) {
        if (err && err.code && err.code !== 'ERR_CANCELED') {
          console.error(err);
          this.loadingJurisdictionsList = false;
        }
      }
    }, 100),
  },

  created() {
    // Retrieve previous search query
    if (this.isJurisdictionsListSearched && this.$router.currentRoute.name === 'JurisdictionsList') {
      this.searchQuery = this.searchJurisdictionsFilter;
    }
    this.currentPage = this.jurisdictionsListCurrentPage;
  },

  methods: {
    ...mapMutations('modal', [
      'OPEN_MODAL'
    ]),
    ...mapActions('jurisdiction', [
      'SEARCH_JURISDICTIONS_LIST',
      'DELETE_JURISDICTION'
    ]),

    async deleteJurisdiction(jurisdiction) {
      this.jurisdictionToDelete = jurisdiction;
      this.OPEN_MODAL({
        modal: 'confirmation',
        open: true,
        title: this.$t('modals.deleteJurisdiction.title'),
        content: this.$t('modals.deleteJurisdiction.content', {
          jurisdiction: this.jurisdictionToDelete.display_name
        }),
        trigger: this.confirmJurisdictionDeletion
      });
    },
    async confirmJurisdictionDeletion() {
      try {
        this.$emit('loading', true);
        await this.DELETE_JURISDICTION(this.jurisdictionToDelete.id);
        this.jurisdictionToDelete = null;
        this.$emit('loading', false);
      } catch (err) {
        if (err && err.response && err.response.status === 409) {
          ErrorService.onError(
            false,
            this.$t(
              'messages.error.jurisdiction.cannotDelete',
              { jurisdiction: this.jurisdictionToDelete.display_name }
            )
          );
        }
        this.$emit('loading', false);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.above-jurisdictionsList {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .jurisdictionsList-pagination {
    margin: 0 1rem;
  }
  .jurisdictionsList-sorter {
    max-width: 30%;
  }
}
</style>